import { Utils } from '@gv/triage-components';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const medicalDetails = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_MEDICAL_DETAILS_LIST}/${patientId}/medical-notes`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );

export const clientInformation = (
  hospitalId: string | number,
  clientId: number | string
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(`${URL.GET_CLIENT_INFORMATION}/${clientId}`, {
      hospitalId,
    })
  );

export const attachmentInformation = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/attachments`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );

export const visitersInformation = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(`${URL.GET_ATTACHMENTS}/${patientId}/visits`, {
      limit,
      offset,
      hospitalId,
    })
  );

export const diagnosis = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/diagnosis`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );
export const vaccinations = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/vaccinations`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );

export const problems = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(`${URL.GET_ATTACHMENTS}/${patientId}/problems`, {
      limit,
      offset,
      hospitalId,
    })
  );

export const appointments = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/appointments`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );
export const prescription = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/prescriptions`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );

export const prescriptionDipensation = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/dispensation`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );

export const labResult = (
  hospitalId: string | number,
  patientId: number | string,
  limit: number,
  offset: any
) =>
  apiLoaderInstance.get(
    Utils.Query.addParamsToUrl(
      `${URL.GET_ATTACHMENTS}/${patientId}/lab-results`,
      {
        limit,
        offset,
        hospitalId,
      }
    )
  );
